import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from 'containers/QuestionnairePage/QuestionGroup/ABTest/Concepts/messages';
import Table from './ConceptsTable';
import Button from './Button';

const AbTestViewOnly = (props) => {
  const { concepts, attributes, refId, hideActions } = props;
  return (
    <div>
      <div className="background-grey-1 border-radius-level-1 padding-top-sm padding-btm-sm shadow-color-6-10-level-2 margin-btm-md">
        <p className="text-weight-bold text-size-secondary color-grey-10 padding-horizontal-sm margin-btm-sm">
          <FormattedMessage {...messages.title} />
        </p>

        <Table
          refId={refId}
          concepts={concepts}
          attributes={attributes}
          readOnly
          hideActions={hideActions}
        />

        <div className="padding-horizontal-sm flex flex-items-center">
          <Button disabled message={messages.addAttribute} />
          <Button disabled message={messages.addConcept} />
        </div>
      </div>
    </div>
  );
};

export default AbTestViewOnly;
